// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 592 ? "common" : chunkId) + "." + {"383":"aac35443","592":"9808fd27"}[chunkId] + ".chunk.css";
};